import { createFileRoute, redirect } from '@tanstack/react-router';

import { SignInPage } from '@/pages/auth/sign-in';

export const Route = createFileRoute('/(auth)/sign-in')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated && context.auth.user?.is_email_verified) {
      throw redirect({ to: '/courses' });
    }
  },
  component: SignInPage,
});
